<template lang="pug">
section.Review.pa2-m.pa4-l
  .mw7-ns.center
    div.pv3(v-if='isTotalInvalid')
      .Box.dark-red.
        #[strong Error:] One of your selected options is now unavailable.#[br.dn.db-ns]
        Please review your choices below.

    div.pv3(v-if='quantities.books < 10')
      .Box.dark-red.
        #[strong Error:] You must choose a book quantity
        in order to proceed to making an estimate.

    div(v-else)
      .flex.flex-auto.flex-wrap
        .w-100.w-60-ns.pa2(class=(!showPrices ? 'w-100-ns' : ''))
          .Box

            .BoxQuantity {{ quantities.books }}

            .BoxText books

        .w-100.w-40-ns.pa2(v-if="showPrices")
          .Box
            .BoxQuantity.green {{ oneBookPrice | price }}

            .BoxText per book ({{this.settings.currency}})

      .flex.flex-auto.flex-wrap.mb4
        .w-100.w-60-ns.pa2(class=(!showPrices ? 'w-100-ns' : ''))
          .Box.mb3
            .BoxQuantity {{ quantities.pages }}

            .BoxText pages per book

          .Box
            .BoxQuantity(v-if='discountPrice > 0') {{ discountPrice | price }}

            .BoxText(v-if='discountPrice > 0') Quantity discount
            .BoxText(v-else style='margin-top: 0') No quantity discount

        .flex.flex-auto.flex-wrap.w-100.w-40-ns.pa2(v-if="showPrices")
          .Box.Box--total.w-100
            .BoxTotalPrice {{ totalPrice | price }}
            .BoxText Total price ({{this.settings.currency}})

    .Section
      .Option.flex.justify-between.items-center(
        v-for='categorySummary, catI in categoriesSummaries',
        v-if='!isCategoryIndexDisabled[catI]'
      )
        div
          .OptionCategory {{ categorySummary.category }}

        div
          .dark-red(v-if='invalidCategoriesIndexes.includes(catI)') Unavailable
          span(v-else) {{ categorySummary.name | ratio }}
</template>

<script>

import numeral from 'numeral'

export default {

  name: 'bookart-review',

  props: [
    'categories',
    'disabledOptions',
    'discounts',
    'pageprices',
    'groups',
    'quantities',
    'selectedOptions',
    'settings',
    'stepsGroupsIndexes',
  ],

  data () {

    var currency = this.settings.currency

    if (this.settings.usdConversionRate!=0) currency = localStorage.currency
    return {
      panelOpened: false,
      currency: currency
    }
  },

  filters: {
    ratio (val) {
      return val.replace(/([0-9]+)x([0-9]+)/gi, '$1 × $2')
    },
    price (val) {
      return numeral(val).format('$ 0,0.00')
    }
  },

  computed: {
    showPrices() {
      return this.settings.showPrices
    },
    exRate () {

      if (this.settings.currency == "USD") var exRate = this.settings.usdConversionRate;
      else var exRate = 1;
      return exRate
    },

    coverPrice () {
      return this.groups.cover.reduce((coverPrice, catI) => {
        if (this.isCategoryIndexDisabled[catI]) return coverPrice
        return coverPrice + this.categories[catI].options[this.selectedOptions[catI]].price
      }, 0)
    },

    setupFee () {
			var setupFees = [	'Cover Lamination', 'Printing', 'Binding Type'];
			var i = 0;
			var setupFee = 0;
			for (i = 0; i < setupFees.length; i++) {
				const catI = this.categories.findIndex(cat => cat.name === setupFees[i])
				const option = this.categories[catI].options[this.selectedOptions[catI]]
				setupFee = setupFee + option.setupFee;
			}
      return setupFee
    },

    printPrice () {
      // Find the pageprice in which the current page quantity fits
      const pagepriceRange = this.pageprices.find(pageprice =>
        this.quantities.books * this.quantities.pages >= pageprice.min &&
        this.quantities.books * this.quantities.pages <= pageprice.max
      )
			const catI = 9
			const printType = this.selectedOptions[catI]
			const cat = this.categories
			const opt = cat[9].options
			const printOpt = opt[printType]
			const printId = printOpt.id
			const price = pagepriceRange.distribution[printId]
			return price
    },

    pagePrice () {

      const pagePrice = this.groups.page.reduce((pagePrice, catI) => {
        const name = this.categories[catI].name

        if (this.isCategoryIndexDisabled[catI]) {
          if (window.DEBUG) console.log(`Category ${name} is disabled, skipping.`)
          return pagePrice
        } else {
          const option = this.categories[catI].options[this.selectedOptions[catI]]
          if (window.DEBUG) console.log(`Category ${name} has option ${option.name} selected. Adding ${option.price}$ to total.`)
          return pagePrice + option.price + this.printPrice
        }
      }, 0)

      return pagePrice
    },

    bookSizeMultiplier () {
      const catI = this.groups.multiplier[0]
      return this.categories[catI].options[this.selectedOptions[catI]].price
    },

    proofingPrice () {
      const catI = this.groups.proofing[0]
      return this.categories[catI].options[this.selectedOptions[catI]].price
    },

    stampingFlatFee () {
      const catI = this.categories.findIndex(cat => cat.name === 'Stamping')
      if (this.categories[catI].options[this.selectedOptions[catI]].price > 0) {
        return this.settings.stampingFlatFee
      } else {
        return 0
      }
    },

    stampingPerBookFee () {
      const catI = this.categories.findIndex(cat => cat.name === 'Stamping')
      if (this.categories[catI].options[this.selectedOptions[catI]].price > 0) {
        return this.settings.stampingPerBookFee * this.categories[catI].options[this.selectedOptions[catI]].price
      } else {
        return 0
      }
    },

    discountPrice () {
      // Find the discount in which the current book quantity fits
      const discountRange = this.discounts.find(discount =>
        this.quantities.books >= discount.min &&
        this.quantities.books <= discount.max
      )

      // If there's none, return a 0$ discount
      if (!discountRange) return 0

      const discountPrices = ['cover', 'page', 'proofing'].reduce((discountPrices, group) => {
        discountPrices[group] = this.groups[group].reduce((coverPrice, catI) => {
          if (this.isCategoryIndexDisabled[catI]) return coverPrice

          const cat = this.categories[catI]
          const opt = cat.options[this.selectedOptions[catI]]
          const percentDiscount = discountRange.distribution[cat.id] || 0
          const discount = opt.price * percentDiscount * opt.discount / 100

          return coverPrice + discount
        }, 0)

        return discountPrices
      }, {})

      const totalDiscount = discountPrices.proofing + this.bookSizeMultiplier * (
        (this.quantities.books * discountPrices.cover) +
        (this.quantities.books * this.quantities.pages * discountPrices.page)
      )

      return totalDiscount >= 0 ? totalDiscount : 0
    },

    oneBookPrice () {
      const flatFeesSplitPerBook = (this.proofingPrice + this.stampingFlatFee + this.setupFee) / this.quantities.books
			const perBookFees = this.stampingPerBookFee
      const discountPricePerBook = this.discountPrice / this.quantities.books
      const coverAndPagePricePerBook = this.coverPrice + (this.quantities.pages * this.pagePrice)
      return ((this.bookSizeMultiplier * coverAndPagePricePerBook) - discountPricePerBook + flatFeesSplitPerBook + perBookFees) * this.exRate
    },

    preTotalPrice () {
      return this.proofingPrice +
        this.stampingFlatFee +
				this.setupFee +
				(this.stampingPerBookFee * this.quantities.books) +
        this.bookSizeMultiplier * (
          (this.quantities.books * this.coverPrice) +
          (this.quantities.books * this.quantities.pages * this.pagePrice)
        )
    },

    totalPrice () {
      return (this.preTotalPrice - this.discountPrice ) * this.exRate
    },

    // Helper that returns an array with a boolean for every category
    // indicating if it every of its options are disabled or not
    isCategoryIndexDisabled () {
      return this.categories.map(cat => {
        return cat.options.every(opt => this.disabledOptions.includes(opt.id))
      })
    },

    invalidCategoriesIndexes () {
      return this.categories.reduce((invalidCategoriesIndexes, cat, catI) => {
        const isCategoryDisabled = this.isCategoryIndexDisabled[catI]
        const selectedOption = cat.options[this.selectedOptions[catI]]
        const selectedOptionId = selectedOption.id
        const isSelectedOptionDisabled = this.disabledOptions.includes(selectedOptionId)
        const isCustomFieldEmpty = selectedOption.customField && !selectedOption.customFieldData
        // return this.selectedOption.customField && !this.selectedOption.customFieldData
        
        if (!isCategoryDisabled && isSelectedOptionDisabled || isCustomFieldEmpty) {
          invalidCategoriesIndexes.push(catI)
        }
        return invalidCategoriesIndexes
      }, [])
    },

    isTotalInvalid () {
      return this.invalidCategoriesIndexes.length > 0
    },

    // Used for displaying categories
    categoriesSummaries () {
      return this.categories.map((cat, catI) => {

        const option = cat.options[this.selectedOptions[catI]]

        return {
          category: cat.name,
          name: option.customField ? `${option.customFieldData} (Custom)` : option.name,
          price: option.price,
        }

      })
    },

  },
}

</script>

<style lang="stylus" scoped>

@import '../../styles/vars'

$background-color = rgb(255, 255, 255)
$border-type = dashed

.Section
  border-top: 2px solid $black
  border-bottom: 2px solid $black

.Box
  border: 2px solid $black
  background: white
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2)
  padding: 1rem
  text-align: center

  &.Box--total
    display: flex
    flex-direction: column
    justify-content: center

.BoxQuantity
  font-size: 1.5em

  &.green
    color: $green

.BoxText
  margin-top: .5rem
  text-transform: uppercase
  font-size: .8em
  font-weight: bold

.BoxTotalPrice
  margin-top: 7px
  color: $green

  font-size: 2em
  @media $breakpoints.l
    font-size: 3em

.Option
  padding: 1rem 0
  border-bottom: 1px dashed $black

  &:last-child
    border-bottom: none

.OptionCategory
  font-weight: bold

hr
  border: 1px solid black
  margin: 0 0 1rem 0

</style>



// WEBPACK FOOTER //
// BookartReview.vue?7826fe97